(() => {
  if (window.cbnCustomPhotoCtaReady) return;
  window.cbnCustomPhotoCtaReady = true;

  function mount() {
    document.querySelectorAll('[data-cbn-photo-cta]').forEach(root => {
      if (root.dataset.photoCtaMounted) return;
      root.dataset.photoCtaMounted = 'true';
      const state = () => {
        const uploader = root.querySelector('.uploadkit-upload-field[data-active="true"]');
        const uploading = !!uploader?.querySelector('.uploadkit-progressbar');
        const ready = !uploading && !!uploader?.querySelector('.uploadkit-attribute-container input[name^="properties["]:not([disabled])')?.value;
        return { uploader, uploading, ready };
      };
      const sync = () => {
        if (!root.isConnected) { observer.disconnect(); return; }
        const { uploading, ready } = state();
        const button = root.querySelector('[data-testid="standalone-add-to-cart"]');
        const label = button?.querySelector('.cbn-add-to-cart-label__action');
        if (!button || !label || !button.dataset.cbnCartLabel) return;
        const pending = !ready && !button.disabled;
        if (root.hasAttribute('data-cbn-photo-pending') !== pending) root.toggleAttribute('data-cbn-photo-pending', pending);
        if (button.disabled) return;
        const text = ready ? button.dataset.cbnCartLabel : uploading ? root.dataset.photoUploading : root.dataset.photoPrompt;
        if (label.textContent.trim() !== text) {
          if (label.childNodes.length === 1 && label.firstChild.nodeType === Node.TEXT_NODE) label.firstChild.nodeValue = text;
          else label.textContent = text;
        }
      };
      const prompt = event => {
        const { uploader, uploading, ready } = state();
        if (ready) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        const uploadButton = uploader?.querySelector('.uploadkit-button');
        if (uploadButton) {
          uploadButton.scrollIntoView({ block: 'center', behavior: 'smooth' });
          uploadButton.focus({ preventScroll: true });
          if (!uploading) uploadButton.click();
        }
        sync();
      };
      root.addEventListener('click', event => {
        if (event.target.closest('[data-testid="standalone-add-to-cart"]')) prompt(event);
      }, true);
      root.addEventListener('submit', prompt, true);
      const observer = new MutationObserver(sync);
      observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['value', 'disabled', 'data-active'] });
      root.addEventListener('change', sync);
      sync();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, { once: true });
  else mount();
  document.addEventListener('shopify:section:load', mount);
})();

